export function findFabricPhotoById(fabricPhotos, photoTypeId) {
  return fabricPhotos.find((x) => x.PhotoTypeId === photoTypeId)?.PhotoUrl;
}
